import React from "react";
import { Clip } from "@clarkinc/zest-design-system/ui";
import { Video } from "~/common/Store/models/Video";
import { ExpandedDescriptionTextSectionTypes } from "~/ProductDetails/ProductDetailPageResult";
import { cls } from "@wss/cls";
export interface ExpandedDescriptionClipProps {
  loops: number | undefined;
  type?: ExpandedDescriptionTextSectionTypes;
  video: Video;
  videoClassNames?: string;
}

// These properties are not all required to be set when videos are uploaded so use the first available
// non-null source.
function getNonNullClipSource(video: Video) {
  if (!video?.videoPath || !video?.sources) {
    return "";
  }
  const videoSource = Object.values(video.sources).find(source => !!source);
  return `${video.videoPath}${videoSource}`;
}
const cdnUrlPrefix = "https://cdn.webstaurantstore.com";
const ExpandedDescriptionClip = ({
  loops,
  type,
  video,
  videoClassNames
}: ExpandedDescriptionClipProps) => {
  const isDoubleImage = type === ExpandedDescriptionTextSectionTypes.TextImageDouble;
  const isTripleImage = type === ExpandedDescriptionTextSectionTypes.TextImageTriple;
  return <div className={cls({
    "exp-crop-padding w-80": true,
    "xs:max-w-[300px] lg:max-w-none": isDoubleImage,
    "py-5 leading-0 flex-[0_0_auto]": !isTripleImage,
    "template-image border-none leading-0 xs:w-full xs:max-w-32 lg:max-w-none": isTripleImage,
    [videoClassNames ?? ""]: !!videoClassNames
  })} data-sentry-component="ExpandedDescriptionClip" data-sentry-source-file="ExpandedDescriptionClip.tsx">
      <Clip altText={video.title ?? ""} data-testid="expanded-description-clip" loops={loops} poster={`${cdnUrlPrefix}${video.poster}`} src={getNonNullClipSource(video)} theme="wss" data-sentry-element="Clip" data-sentry-source-file="ExpandedDescriptionClip.tsx" />
    </div>;
};
export default ExpandedDescriptionClip;